import { LifeProducts } from '@app/domain/model/eshop/life/LifeProducts';
import { AuthState } from '@app/infrastructure/auth/model/AuthState';
import { FormState } from '@app/lib/form/contracts/FormState';
import { PurchaseLifeInsuranceResult } from '@app/service/eshop/life/actions/purchaseLifeInsurance';
import { useEditController } from '@app/app/esales/life/_sections/LifeInsuranceWizardSection/hooks/useEditController';
import { LIFE_INSURANCE_STEPS } from '@app/app/esales/life/_sections/steps/LIFE_INSURANCE_STEPS';
import { YourInformationCard } from '@app/app/esales/life/_sections/steps/OverviewContractStep/YourInformationCard';
import { FavoredPersonsCard } from '@app/app/esales/life/_sections/steps/OverviewContractStep/FavoredPersonsCard';
import { ContractInformationCard } from '@app/app/esales/life/_sections/steps/OverviewContractStep/ContractInformationCard';

interface Props {
    formState: FormState<PurchaseLifeInsuranceResult>;
    authState: AuthState;
    lifeProducts: LifeProducts;
    editController: ReturnType<typeof useEditController>;
}

export function OverviewContractStep({ formState, authState, lifeProducts, editController }: Props) {
    const handleEditDefenses = () =>
        editController.handleEditDefenses?.(LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.OVERVIEW_OF_CONTRACT);

    const handleEditPaymentSchedule = () =>
        editController.handleEditPaymentSchedule?.(LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.OVERVIEW_OF_CONTRACT);

    const handleEditContactInfo = () =>
        editController.handleEditContactInfo?.(LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.OVERVIEW_OF_CONTRACT);

    const handleEditTaxInformation = () =>
        editController.handleEditTaxInformation?.(LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.OVERVIEW_OF_CONTRACT);

    const handleEditLifestyleAndHealth = () =>
        editController.handleEditLifestyleAndHealth?.(LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.OVERVIEW_OF_CONTRACT);

    const handleEditBeneficiaries = () =>
        editController.handleEditBeneficiaries?.(LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.OVERVIEW_OF_CONTRACT);

    const handleEditContractDuration = () =>
        editController.handleEditContractDuration?.(LIFE_INSURANCE_STEPS.SIGNING_THE_CONTRACT.OVERVIEW_OF_CONTRACT);

    return (
        <div className="mb-20 flex w-full flex-col gap-6">
            <YourInformationCard
                handleEditContactInfo={handleEditContactInfo}
                handleEditTaxInformation={handleEditTaxInformation}
                handleEditLifestyleAndHealth={handleEditLifestyleAndHealth}
                formState={formState}
                authState={authState}
                lifeProducts={lifeProducts}
            />
            <FavoredPersonsCard formState={formState} handleEditBeneficiaries={handleEditBeneficiaries} />
            <ContractInformationCard
                formState={formState}
                handleEditContractDuration={handleEditContractDuration}
                handleEditPaymentSchedule={handleEditPaymentSchedule}
                handleEditDefenses={handleEditDefenses}
            />
        </div>
    );
}
